import React from 'react';

const flattenData = (data) => {
  let result = [];
  data.forEach((row) => {
    if (row.children && row.children.length > 0) {
      // If row has children, recurse into them but don't add the parent row to result
      result = result.concat(flattenData(row.children));
    } else {
      // Only add leaf nodes (rows with no children) to the CSV
      const rowData = { ...row.dimensions, ...row.metrics };
      result.push(rowData);
    }
  });
  return result;
};

const ExportCSV = ({ data, columns }) => {
  const exportToCSV = () => {
    if (!data || data.length === 0) return;

    const flatData = flattenData(data);
    
    // Create header row
    const header = columns.join(',');
    
    // Create data rows
    const csvRows = flatData.map((row) => {
      return columns.map((col) => {
        let val = row[col];
        // Handle undefined or null
        if (val === undefined || val === null) val = '';
        // Escape quotes and wrap in quotes if contains comma
        if (typeof val === 'string' && val.includes(',')) {
          val = `"${val.replace(/"/g, '""')}"`;
        }
        return val;
      }).join(',');
    });
    
    const csvContent = [header, ...csvRows].join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'analytics_report.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <button
      onClick={exportToCSV}
      style={{
        padding: '8px 16px',
        backgroundColor: '#28a745',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontWeight: 'bold'
      }}
    >
      Export CSV
    </button>
  );
};

export default ExportCSV;
